import { maxBy, minBy, assign } from 'lodash'
import moment from 'moment'

export default class CatchmentDto {
    constructor(obj) {
        assign(this, obj)
        this.usedSdage = minBy(obj.sdages, sdage => sdage.startDate ?? 0)?.codeSDAGE
        const lastSdage = maxBy(obj.sdages, sdage => sdage.startDate ?? 0)
        this.activeSdage = lastSdage && (!lastSdage.endDate || (lastSdage?.endDate > moment().valueOf() && lastSdage?.startDate < moment().valueOf()))
    }
}